module.exports = __webpack_public_path__ + "img/img1.f04d0fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img1.png
// module id = 361
// module chunks = 0